import React from "react";
import "./Services.css";

function Services() {
  return (
    <div className="Servies-bdy">
      <div className="Services-content">
        Services :
        <br />
        <div className="Services-srv">
          ~Renewable Energy Optimization
          <br />
          ~Industrial Engineering Solutions
          <br />
          ~Technical Breifing
          <br />
          ~Data Managment
          <br />
          ~Sizing and Modeling
        </div>
      </div>
    </div>
  );
}

export default Services;
